import { buildTutorialTargetMissingHint } from '../buildTargetMissingHint';
import type { TutorialDefinition, TutorialRecover } from '../types';

/** 페이지·모달을 닫아 대상을 잃었을 때 복구·안내 문구에 쓰는 설정 */
const R = {
  classSettingsMenu: {
    openSelectors: ['.cp-topnav-account-menu-burger-btn', '.cp-user-account-menu-item-class-settings'],
    pageLabel: '클래스 설정',
    accessLabel: '상단 계정 메뉴',
  },
  classRegisterForm: {
    openSelectors: [
      '.cp-topnav-account-menu-burger-btn',
      '.cp-user-account-menu-item-class-settings',
      '.primary-row-button.cp-compact-btn',
    ],
    pageLabel: '클래스 설정',
    openLabel: '클래스 등록',
    accessLabel: '상단 계정 메뉴',
  },
  academic: { path: '/academic-calendar', pageLabel: '학사일정' },
  classSchedule: { path: '/class-schedule', pageLabel: '수업시간' },
  gradeTrack: { path: '/grade-track', pageLabel: '편제 및 기준시수' },
  classMembers: {
    openSelectors: [
      '.cp-topnav-account-menu-burger-btn',
      '.cp-user-account-menu-item-class-members',
    ],
    pageLabel: '클래스 멤버 설정',
    accessLabel: '상단 계정 메뉴',
  },
  profileModal: {
    openSelectors: [
      '.cp-topnav-account-menu-burger-btn',
      '.cp-user-account-menu-item-class-members',
      '.cp-class-members-profile-btn',
    ],
    pageLabel: '클래스 멤버 설정',
    openLabel: '프로필',
    accessLabel: '상단 계정 메뉴',
  },
  annualTt: { path: '/annual-timetable', pageLabel: '연간시간표' },
  ttSettings: {
    path: '/annual-timetable',
    openSelector: '.cp-btn-annual-timetable-settings',
    pageLabel: '연간시간표',
    openLabel: '기초 시간표 설정',
  },
  eventModal: {
    path: '/annual-timetable',
    openSelector: 'text:고정 프로그램(행사) 등록@.cp-annual-action-label-full',
    pageLabel: '연간시간표',
    openLabel: '고정 프로그램(행사) 등록',
  },
  fixedManage: {
    path: '/annual-timetable',
    openSelector: 'text:고정 프로그램 관리@.cp-annual-action-label-full',
    pageLabel: '연간시간표',
    openLabel: '고정 프로그램 관리',
  },
  shortDay: {
    path: '/annual-timetable',
    openSelector: 'text:증배 및 단축일 등록@.cp-annual-action-label-full',
    pageLabel: '연간시간표',
    openLabel: '증배 및 단축일 등록',
  },
  shortManage: {
    path: '/annual-timetable',
    openSelector: 'text:증배 및 단축일 관리@.cp-annual-action-label-full',
    pageLabel: '연간시간표',
    openLabel: '증배 및 단축일 관리',
  },
  hoursAdjust: {
    path: '/annual-timetable',
    openSelector: '.cp-annual-hours-adjust-open-btn',
    pageLabel: '연간시간표',
    openLabel: '기준시수 맞춤 시간표 자동 조정',
  },
  hoursChecklist: {
    path: '/annual-timetable',
    openSelectors: [
      '.cp-annual-hours-adjust-open-btn',
      'text:시수 조정 체크리스트 생성 (2)@.cp-annual-hours-adjust-checklist-cta',
    ],
    pageLabel: '연간시간표',
    openLabel: '시수 조정 체크리스트',
  },
  hoursChecklistFloat: {
    path: '/annual-timetable',
    pageLabel: '연간시간표',
    openLabel: '시수 조정 체크리스트',
  },
  operationPlan: {
    path: '/annual-timetable',
    openSelector: '.cp-btn-annual-action-operation-plan',
    pageLabel: '연간시간표',
    openLabel: '연간 수업 일수 및 시수 운영계획',
  },
  annualProgress: { path: '/annual-progress-term1', pageLabel: '연간진도표' },
  crossTopicModal: {
    path: '/annual-progress-term1',
    openSelector: 'text:1,2학기 범교과 주제 카운팅@.cp-annual-progress-year-action-label-full',
    pageLabel: '연간진도표',
    openLabel: '1,2학기 범교과 주제 카운팅',
  },
  progressPlanModal: {
    path: '/annual-progress-term1',
    openSelector: 'text:연간 진도 계획 및 편제별 진도 계획@.cp-annual-progress-year-action-label-full',
    pageLabel: '연간진도표',
    openLabel: '연간 진도 계획 및 편제별 진도 계획',
  },
  behaviorModal: {
    path: '/annual-progress-term1',
    openSelector: '.cp-annual-progress-col-log',
    pageLabel: '연간진도표',
    openLabel: '행동특성',
  },
  trackProgram: {
    pageLabel: '편제별 프로그램',
    accessLabel: '사이드 메뉴',
  },
  trackImportMethod: {
    pageLabel: '편제별 프로그램',
    openLabel: '학습내용 가져오기',
    accessLabel: '사이드 메뉴',
  },
  trackImportModal: {
    pageLabel: '편제별 프로그램',
    openLabel: '기본 학습내용 데이터 가져오기',
    accessLabel: '사이드 메뉴',
  },
  programPage: {
    path: '/annual-progress-term1',
    openSelector: 'text:선택셀 프로그램 탐색@.cp-annual-progress-action-label-full',
    pageLabel: '프로그램(고정·프로젝트·편제별)',
    accessLabel: '사이드 메뉴',
  },
  programCrossModal: {
    path: '/annual-progress-term1',
    openSelectors: [
      'text:선택셀 프로그램 탐색@.cp-annual-progress-action-label-full',
      '.cp-program-progress-scroll-wrap tbody td:nth-child(17)',
    ],
    pageLabel: '프로그램(고정·프로젝트·편제별)',
    openLabel: '범교과 칸',
    accessLabel: '사이드 메뉴',
  },
  programCrossExampleModal: {
    path: '/annual-progress-term1',
    openSelectors: [
      'text:선택셀 프로그램 탐색@.cp-annual-progress-action-label-full',
      '.cp-program-progress-scroll-wrap tbody td:nth-child(17)',
      '.cp-program-cross-catalog-import-btn',
    ],
    pageLabel: '프로그램(고정·프로젝트·편제별)',
    openLabel: '범교과 예시문 가져오기',
    accessLabel: '사이드 메뉴',
  },
  programMemoModal: {
    path: '/annual-progress-term1',
    openSelectors: [
      'text:선택셀 프로그램 탐색@.cp-annual-progress-action-label-full',
      '.cp-program-progress-scroll-wrap tbody td:nth-child(18)',
    ],
    pageLabel: '프로그램(고정·프로젝트·편제별)',
    openLabel: '메모 칸',
    accessLabel: '사이드 메뉴',
  },
  programEvalDropdown: {
    path: '/annual-progress-term1',
    openSelectors: [
      'text:선택셀 프로그램 탐색@.cp-annual-progress-action-label-full',
      '.cp-program-progress-scroll-wrap tbody td:nth-child(19)',
    ],
    pageLabel: '프로그램(고정·프로젝트·편제별)',
    openLabel: '평가 칸',
    accessLabel: '사이드 메뉴',
  },
  programClassrecordModal: {
    path: '/annual-progress-term1',
    openSelectors: [
      'text:선택셀 프로그램 탐색@.cp-annual-progress-action-label-full',
      '.cp-program-progress-scroll-wrap tbody td:nth-child(20)',
    ],
    pageLabel: '프로그램(고정·프로젝트·편제별)',
    openLabel: '수업기록 칸',
    accessLabel: '사이드 메뉴',
  },
} as const satisfies Record<string, TutorialRecover>;

const RECOVER_BY_STEP_ID: Record<string, TutorialRecover> = {
  'open-class-settings': R.classSettingsMenu,
  'open-class-register': R.classSettingsMenu,
  'register-class-modal': R.classRegisterForm,
  'class-settings-after-register': R.classSettingsMenu,
  'academic-calendar-register-class': R.academic,
  'academic-calendar-settings': R.academic,
  'academic-holiday-auto': R.academic,
  'academic-holiday-custom': R.academic,
  'academic-weekend-class': R.academic,
  'academic-summary': R.academic,
  'save-academic-calendar': R.academic,
  'class-schedule-register-class': R.classSchedule,
  'class-schedule-kind': R.classSchedule,
  'class-schedule-name': R.classSchedule,
  'class-schedule-time': R.classSchedule,
  'class-schedule-weekday': R.classSchedule,
  'save-class-schedule': R.classSchedule,
  'grade-track-input': R.gradeTrack,
  'grade-track-input-second': R.gradeTrack,
  'grade-track-category': R.gradeTrack,
  'grade-track-wildcard': R.gradeTrack,
  'grade-track-program-mode': R.gradeTrack,
  'grade-track-criteria': R.gradeTrack,
  'grade-track-fill-remaining': R.gradeTrack,
  'save-grade-track': R.gradeTrack,
  'class-members-group': R.classMembers,
  'class-members-add': R.classMembers,
  'class-members-name-gender': R.classMembers,
  'class-members-entry': R.classMembers,
  'class-members-profile-open': R.classMembers,
  'class-members-profile-basic': R.profileModal,
  'class-members-profile-sets': R.profileModal,
  'class-members-profile-photo': R.profileModal,
  'class-members-profile-summary': R.profileModal,
  'class-members-profile-close': R.profileModal,
  'class-members-fill-remaining': R.classMembers,
  'save-members': R.classMembers,
  'preset-status-dots': R.gradeTrack,
  'go-track-program': R.trackProgram,
  'track-import-learning-btn': R.trackImportMethod,
  'track-import-method-csv': R.trackImportMethod,
  'track-import-method-workspace': R.trackImportMethod,
  'track-import-modal-guide': R.trackImportModal,
  // practice·다른 편제 가져오기는 모달 닫힘·페이지 이동 중에도 "다음"으로 진행할 수 있어야 해서 recover를 두지 않음
  'open-timetable-settings': R.annualTt,
  'fixed-program-colors': R.ttSettings,
  'dedicated-program-colors': R.ttSettings,
  'labeling-colors': R.ttSettings,
  'base-timetable-input': R.ttSettings,
  'save-timetable-settings': R.ttSettings,
  'close-timetable-settings': R.ttSettings,
  'event-modal-open': R.annualTt,
  'event-modal-date-period': R.eventModal,
  'event-modal-slot-name': R.eventModal,
  'event-modal-color-name': R.eventModal,
  'event-modal-classes': R.eventModal,
  'event-modal-apply': R.eventModal,
  'event-modal-repeat': R.annualTt,
  'event-modal-drag-method': R.annualTt,
  'fixed-manage-open': R.annualTt,
  'fixed-manage-explain': R.fixedManage,
  'fixed-manage-close': R.fixedManage,
  'shortday-modal-open': R.annualTt,
  'shortday-modal-date-period': R.shortDay,
  'shortday-modal-classes': R.shortDay,
  'shortday-modal-apply': R.shortDay,
  'shortday-modal-drag-method': R.annualTt,
  'shortday-manage-open': R.annualTt,
  'shortday-manage-explain': R.shortManage,
  'shortday-manage-close': R.shortManage,
  'apply-base-timetable-term1': R.annualTt,
  'apply-base-timetable-term2': R.annualTt,
  'open-hours-adjust': R.annualTt,
  'hours-adjust-learning-plan': R.hoursAdjust,
  'hours-adjust-phase1-btn': R.hoursAdjust,
  'hours-adjust-phase1-checklist-btn': R.hoursAdjust,
  'hours-adjust-phase2-btn': R.hoursAdjust,
  'hours-adjust-phase2-checklist-btn': R.hoursAdjust,
  'hours-adjust-checklist-apply-btn': R.hoursChecklist,
  'hours-adjust-checklist-close': R.hoursChecklistFloat,
  'labeling-color-apply': R.annualTt,
  'cell-move-left': R.annualTt,
  'cell-move-right': R.annualTt,
  'cell-move-up': R.annualTt,
  'cell-move-down': R.annualTt,
  'swap-region-a': R.annualTt,
  'swap-region-b': R.annualTt,
  'swap-regions': R.annualTt,
  'annual-timetable-compose': R.annualTt,
  'save-timetable': R.annualTt,
  'operation-plan-exceed-intro': R.annualTt,
  'operation-plan-hours-summary': R.annualTt,
  'operation-plan-week-hours-hover': R.annualTt,
  'operation-plan-week-memo-click': R.annualTt,
  'operation-plan-week-memo-popup': R.annualTt,
  'operation-plan-open-btn': R.annualTt,
  'operation-plan-modal': R.operationPlan,
  'annual-progress-today-lesson': R.annualProgress,
  'nav-explore-timetable-select': R.annualProgress,
  'nav-explore-timetable': R.annualProgress,
  'nav-open-annual-timetable-via-sidebar': R.annualProgress,
  'nav-back-to-progress-from-timetable-select': R.annualTt,
  'nav-back-to-progress-from-timetable': R.annualTt,
  'nav-open-annual-progress-mid-via-sidebar': R.annualTt,
  'nav-explore-program-select': R.annualProgress,
  'nav-explore-program': R.annualProgress,
  'nav-open-program-via-sidebar': R.annualProgress,
  'program-learning-input': R.programPage,
  'program-row-add': R.programPage,
  'program-row-remove': R.programPage,
  'program-row-merge': R.programPage,
  'program-duplicate': R.programPage,
  'program-row-up': R.programPage,
  'program-row-down': R.programPage,
  'program-period-count': R.programPage,
  'program-copy': R.programPage,
  'program-cut': R.programPage,
  'program-paste': R.programPage,
  'program-delete': R.programPage,
  'program-head-page': R.programPage,
  'program-head-cross': R.programPage,
  'program-head-memo': R.programPage,
  'program-head-eval': R.programPage,
  'program-head-classlog': R.programPage,
  'program-cross-cell-click': R.programCrossModal,
  'program-cross-example-modal': R.programCrossExampleModal,
  'program-memo-cell-click': R.programMemoModal,
  'program-eval-cell-click': R.programEvalDropdown,
  'program-eval-longpress-hint': R.programEvalDropdown,
  'program-classrecord-cell-click': R.programClassrecordModal,
  'nav-back-to-annual-progress-final': R.programPage,
  'nav-open-annual-progress-via-sidebar': R.programPage,
  'annual-progress-learning-display': R.annualProgress,
  'cross-topic-count-btn': R.annualProgress,
  'cross-topic-count-modal': R.crossTopicModal,
  'progress-plan-btn': R.annualProgress,
  'progress-plan-modal': R.progressPlanModal,
  'progress-plan-neis-click': R.progressPlanModal,
  'progress-plan-neis-export': R.progressPlanModal,
  'behavior-cell-click': R.annualProgress,
  'behavior-modal': R.behaviorModal,
};

const coreOnboardingRaw: TutorialDefinition = {
  id: 'core-onboarding',
  title: '기본 교육과정 구성',
  summary: '클래스 등록부터 편제 구성, 시수 조정, 학습내용 등록 및 조정 까지, 기본 교육과정 편성 설정을 한 번에 끝내요.',
  steps: [
    {
      id: 'intro',
      mascot:
        '안녕하세요! 처음 오셨네요. 클래스 등록부터 연간시간표·진도표 설정까지, 시작에 필요한 흐름을 하나씩 알려드릴게요.\n\n**중요 안내**\n· 튜토리얼 진행은 기록된 데이터가 없는 첫 사용자들을 기준으로 합니다. 기존 데이터가 있는 사용자는 튜토리얼 진행 중 데이터를 덮어쓰지 않도록 주의해 주세요!\n· 튜토리얼 진행 중 예상치 못한 상황으로 더 이상 진행이 되지 않을 땐 튜토리얼을 종료하고, 종료된 단계부터 다시 실행해 주세요.',
      actionLabel: '시작하기',
      presentation: 'intro',
      cardTitle: '기본 교육과정 구성을 시작해요!',
      placement: 'center',
    },
    {
      id: 'open-account-menu',
      mascot: '가장 먼저 클래스를 등록해요. 오른쪽 위 계정 메뉴 버튼을 눌러주세요.',
      targetSelector: '.cp-topnav-account-menu-burger-btn',
      placement: 'bottom',
      section: '[기본 메뉴 설정] 클래스 등록',
      sectionMascot: '먼저 클래스를 만들고 등록하는 방법부터 알아볼게요.',
    },
    {
      id: 'open-class-settings',
      mascot: '메뉴에서 "클래스 등록 및 설정"을 눌러주세요.',
      targetSelector: '.cp-user-account-menu-item-class-settings',
      placement: 'left',
    },
    {
      id: 'open-class-register',
      mascot: '"클래스 등록하기"를 눌러 학년과 반을 만들어봐요.',
      targetSelector: '.primary-row-button.cp-compact-btn',
    },
    {
      id: 'register-class-modal',
      mascot:
        '이 창에서 클래스 이름을 입력하고 학년을 선택한 뒤 "저장"을 눌러 주세요. 학년을 고르면 대표 클래스로 설정할 수도 있어요. 저장을 눌러야 다음으로 넘어가요.',
      targetSelector: '.cp-class-register-modal',
      advanceSelector: '.cp-class-register-modal .cp-modal-footer .cp-btn-primary',
    },
    {
      id: 'class-settings-after-register',
      mascot:
        '클래스가 목록에 등록됐어요. 같은 방식으로 다른 학년·반도 더 만들 수 있어요. 이제 오른쪽 위 "×"를 눌러 이 창을 닫아주세요.',
      targetSelector: '.cp-class-settings-modal-panel',
      advanceSelector: '.cp-class-settings-modal-close',
    },
    {
      id: 'go-academic-calendar',
      mascot: '클래스를 만들었어요! 이제 학사일정을 등록하러 가볼까요? 사이드바에서 "학사일정"을 눌러주세요.',
      targetSelector: 'a[href="/academic-calendar"]',
      placement: 'right',
      section: '[클래스 사전 설정] 학사일정',
      sectionMascot: '학년도·방학·공휴일 등 학사일정을 등록하는 구간이에요.',
    },
    {
      id: 'academic-calendar-register-class',
      mascot:
        '먼저 앞에서 만든 클래스가 이 학사일정에 연결되어 있는지 확인해 주세요. 없으면 "+ 클래스 등록"을 눌러 클래스를 연결해요. 이미 연결되어 있다면 "다음"으로 넘어가도 돼요.',
      targetSelector: '.cp-academic-calendar-group .cp-program-color-class-add-btn',
      manualAdvance: true,
      followUp: {
        targetSelector: '.cp-class-picker-modal',
        mascot:
          '목록에서 학사일정을 적용할 클래스를 눌러 연결하세요. 이미 연결돼 있거나 확인할 필요 없으면 "닫기"를 눌러 닫아주세요.',
      },
    },
    {
      id: 'academic-calendar-settings',
      mascot:
        '왼쪽 "학사일정 등록" 블럭에서 학년도와 학년도 시작·종료일, 여름·겨울방학 기간을 입력해 주세요. 필수 항목을 채우면 학기와 수업일 수가 자동으로 계산돼요.',
      targetSelector: '.academic-calendar-settings-card',
      manualAdvance: true,
    },
    {
      id: 'academic-holiday-auto',
      mascot:
        '오른쪽 "공휴일 및 휴업일 등록"에서 "공휴일 자동 등록"을 눌러 법정 공휴일을 한번에 넣어보세요.',
      targetSelector: '.holiday-auto-register-btn',
      manualAdvance: true,
    },
    {
      id: 'academic-holiday-custom',
      mascot:
        '재량휴업일·학교 행사 등 자동 등록에 없는 날은 날짜와 메모를 입력한 뒤 "등록"으로 따로 추가해 주세요.',
      targetSelector: '.academic-calendar-holiday-card .holiday-register-row',
      manualAdvance: true,
    },
    {
      id: 'academic-weekend-class',
      mascot:
        '토요일·일요일에 수업하는 날이 있으면 여기 등록해요. 흔치 않은 경우라서, 해당 날이 없으면 그냥 건너뛰어도 괜찮아요.',
      targetSelector: '.academic-calendar-weekend-class-card',
      manualAdvance: true,
    },
    {
      id: 'academic-summary',
      mascot:
        '아래에 학기별 수업일 수와 총 수업일 수가 계산되어 보여요. 기간과 일수가 맞는지 한 번 확인해 주세요.',
      targetSelector: '.academic-summary',
      manualAdvance: true,
    },
    {
      id: 'save-academic-calendar',
      mascot: '입력이 끝났다면 오른쪽 위 "저장하기"를 눌러 학사일정을 저장해 주세요.',
      targetSelector: '.cp-btn-save-all',
      manualAdvance: true,
    },
    {
      id: 'go-class-schedule',
      mascot: '다음은 요일별 수업시간이에요. 사이드바에서 이동해볼게요.',
      targetSelector: 'a[href="/class-schedule"]',
      placement: 'right',
      section: '[클래스 사전 설정] 수업시간 및 요일별 기준 수업시수',
      sectionMascot: '요일별 수업 시작·종료 시간을 설정하는 구간이에요.',
    },
    {
      id: 'class-schedule-register-class',
      mascot:
        '먼저 이 설정을 적용할 클래스가 등록되어 있는지 확인해 주세요. 없으면 "+ 클래스 등록"을 눌러 클래스를 연결해요.',
      targetSelector: '.cp-class-schedule-section-header .cp-program-color-class-add-btn',
      manualAdvance: true,
      followUp: {
        targetSelector: '.cp-class-picker-modal',
        mascot: '목록에서 이 설정을 적용할 클래스를 눌러 연결하세요. 이미 연결돼 있다면 "닫기"를 눌러 닫아주세요.',
      },
    },
    {
      id: 'class-schedule-kind',
      mascot:
        '"구분"에서 각 타임을 수업·활동·방과후로 나눠요. 수업은 정규 교시, 활동은 아침활동 같은 특별 시간, 방과후는 방과후 프로그램에 써요.',
      targetSelector: '.cp-class-schedule-unified-table tbody tr td:nth-child(2) select',
      manualAdvance: true,
    },
    {
      id: 'class-schedule-name',
      mascot:
        '"이름"은 구분에 따라 달라요. 수업은 순서대로 1교시·2교시…로 자동 표시되고, 활동은 직접 이름을 적고, 방과후는 자동으로 정해져요.',
      targetSelector: '.cp-class-schedule-unified-table tbody tr td:nth-child(3) input',
      manualAdvance: true,
    },
    {
      id: 'class-schedule-time',
      mascot:
        '시작시각과 운영시간(분)만 입력하면 종료시각은 자동으로 계산돼요. 필요한 교시 시간을 맞춰 주세요.',
      targetSelector:
        '.cp-class-schedule-unified-table tbody tr td:nth-child(4) .cp-edu-time-input, .cp-class-schedule-unified-table tbody tr td:nth-child(5) input',
      manualAdvance: true,
    },
    {
      id: 'class-schedule-weekday',
      mascot:
        '오른쪽 "요일별 기준 수업시수"에서 각 요일의 마지막 교시 칸을 클릭해 그날 몇 교시까지인지 설정해요.',
      targetSelector: '.cp-period-toggle-btn',
      manualAdvance: true,
    },
    {
      id: 'save-class-schedule',
      mascot: '설정을 마쳤다면 오른쪽 위 "저장하기"를 눌러주세요.',
      targetSelector: '.cp-btn-save-all',
      manualAdvance: true,
    },
    {
      id: 'go-grade-track',
      mascot: '이제 교과(편제)를 등록하러 가볼게요.',
      targetSelector: 'a[href="/grade-track"]',
      placement: 'right',
      section: '[클래스 사전 설정] 편제(교과)',
      sectionMascot: '교과 편제와 기준시수를 등록하는 구간이에요.',
    },
    {
      id: 'grade-track-input',
      mascot:
        '편제명과 시간표명을 입력한 뒤 "등록"을 눌러요.\n연습으로 먼저 **음악 - 음악**(편제명·시간표명 모두 "음악")을 입력하고 등록해 보세요.',
      targetSelector:
        '.form-row.label-row .track-name-input, .form-row.label-row .track-alias-input, .form-row.label-row .primary-row-button',
      advanceSelector: '.form-row.label-row .primary-row-button',
      advanceImmediately: true,
    },
    {
      id: 'grade-track-input-second',
      mascot:
        '한 번 더 등록해 볼게요.\n이번엔 **음악 - 국악**(편제명 "음악" / 시간표명 "국악")을 입력하고 등록해 주세요.\n같은 편제에 시간표명이 여러 개 쌓여요.',
      targetSelector:
        '.form-row.label-row .track-name-input, .form-row.label-row .track-alias-input, .form-row.label-row .primary-row-button',
      advanceSelector: '.form-row.label-row .primary-row-button',
      advanceImmediately: true,
    },
    {
      id: 'grade-track-category',
      mascot:
        '편제 블럭의 "정규"/"기타"를 눌러 속성을 바꿔요. 정규 편제는 시수 계산에 포함되고, 기타 편제는 시수 계산에서 제외돼요.',
      targetSelector: '.track-category-toggle-badge',
      manualAdvance: true,
    },
    {
      id: 'grade-track-wildcard',
      mascot:
        '편제명 아래 ( ) 칸은 와일드카드예요. 시간표 셀 글자 뒤에 (음)처럼 입력하면 그 편제의 기본 시간표로 시수가 카운팅돼요. 예: 전담(음), 밴드(음) → 음악 편제.',
      targetSelector: '.track-col-wildcard, .cp-grade-track-wildcard-hint',
      manualAdvance: true,
    },
    {
      id: 'grade-track-program-mode',
      mascot:
        '"프로그램(진도표) 생성 방법"을 눌러 전환해요. 시간표별은 입력된 시간표마다 프로그램(진도표)을 만들고, 동기화는 대표 시간표 프로그램(진도표)을 미러링해 하나로 관리하며, 편제별은 편제당 프로그램(진도표) 하나예요.',
      targetSelector: '.track-split-single-toggle-btn',
      manualAdvance: true,
    },
    {
      id: 'grade-track-criteria',
      mascot: '아래에 "기준시수"를 입력해 이 편제의 최소 기준 시수를 정해 주세요.',
      targetSelector: '.track-col-criteria',
      manualAdvance: true,
    },
    {
      id: 'grade-track-fill-remaining',
      mascot:
        '해당 클래스의 편제 및 시간표 입력 양식을 모두 입력해주세요. 입력이 완료되면 "다음" 버튼을 눌러주세요.',
      targetSelector: '.cp-timetable-hub-page .cp-card',
      manualAdvance: true,
    },
    {
      id: 'save-grade-track',
      mascot: '설정을 마쳤다면 오른쪽 위 "저장하기"를 눌러주세요.',
      targetSelector: '.cp-btn-save-all',
      manualAdvance: true,
    },
    {
      id: 'go-class-members',
      mascot:
        '이제 학생들을 등록해요. 상단 우측 계정 메뉴에서 "클래스 멤버 설정"을 열어 주세요.',
      targetSelector:
        '.cp-topnav-account-menu-burger-btn, .cp-user-account-menu-item-class-members',
      placement: 'left',
      section: '[클래스 멤버 설정] 클래스 멤버',
      sectionMascot: '학생 그룹·멤버·프로필을 등록하는 구간이에요.',
    },
    {
      id: 'class-members-group',
      mascot:
        '먼저 섹션 위 학급 버튼 오른쪽 "+ 학급"으로 멤버 묶음을 만들어요. 학급은 보통 단일 학급 단위로 두고, 과제관리·포인트·아이템 관리도 이 학급 단위로 이뤄져요. 이미 학급이 있다면 "다음"을 눌러 넘어가도 돼요.',
      targetSelector: '.cp-class-members-group-add',
      manualAdvanceIfExists: '.cp-class-members-group-tab',
    },
    {
      id: 'class-members-add',
      mascot:
        '"멤버 추가"를 눌러 학생 행을 추가해 보세요. 이미 멤버가 있다면 "다음"을 눌러 넘어가도 돼요.',
      targetSelector: '.cp-class-members-add-btn',
      manualAdvanceIfExists: '.cp-class-members-table tbody tr',
    },
    {
      id: 'class-members-name-gender',
      mascot: '이름과 성별을 입력해 주세요.',
      targetSelector:
        '.cp-class-members-col-name .cp-class-members-input, .cp-class-members-col-gender .cp-class-members-select',
      manualAdvance: true,
    },
    {
      id: 'class-members-entry',
      mascot:
        '입장번호는 멤버가 들어올 때 인증에 쓰는 6자리 번호예요. 멤버마다 무작위로 정해지며, 필요하면 바꿔 주세요.',
      targetSelector: '.cp-class-members-col-entry .cp-class-members-entry-input',
      manualAdvance: true,
    },
    {
      id: 'class-members-profile-open',
      mascot: '프로필 칸을 눌러 프로필 이미지를 골라 볼까요?',
      targetSelector: '.cp-class-members-profile-btn',
    },
    {
      id: 'class-members-profile-basic',
      mascot: '"기본" 탭이에요. 바로 쓸 수 있는 기본 프로필 기능을 살펴보세요.',
      targetSelector: 'text:기본@.cp-profile-img-tab, .cp-profile-img-grid',
      manualAdvance: true,
    },
    {
      id: 'class-members-profile-sets',
      mascot:
        '기본 세트가 아닌 관리자 세트는 "잠금 프로필 세트"예요. 탭을 눌러 잠긴 프로필을 살펴보고, 잠금 프로필 세트를 선택하면 다음으로 넘어가요.',
      targetSelector: '[data-tutorial-profile-set="locked-admin"]',
      spotlightUnion: true,
      targetMissingHint:
        '잠금 프로필 세트 탭을 찾지 못했어요. 관리자가 사용 중인 프로필 세트가 있는지 확인해 주세요.',
    },
    {
      id: 'class-members-profile-photo',
      mascot: '"사진 프로필" 탭을 눌러 기능을 살펴보세요. 탭을 선택하면 다음으로 넘어가요.',
      targetSelector: '.cp-profile-img-tab-photo',
    },
    {
      id: 'class-members-profile-summary',
      mascot:
        '멤버별 프로필 이미지를 어떻게 설정하는지 알았다면 시간이 날 때 각 멤버별 프로필을 선택해주세요. 지금은 다음 단계로 넘어가볼게요.',
      targetSelector: '.cp-profile-img-modal',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'class-members-profile-close',
      mascot: '다음으로 가려면 이 모달을 닫아야 해요. "×" 버튼을 눌러 닫아주세요.',
      targetSelector: '.cp-profile-img-modal-close',
    },
    {
      id: 'class-members-fill-remaining',
      mascot:
        '"+ 학급"과 "멤버 추가"로 학급 멤버를 더 등록해 주세요. 모두 등록이 완료되면 "다음"을 눌러 주세요.',
      targetSelector: '.cp-class-members-section',
      // 섹션은 하이라이트하되 학급 삭제·자리배치는 잠금
      blockClickSelectors: '.cp-class-members-group-trash, .cp-class-members-seat-btn',
      manualAdvance: true,
      placement: 'right',
      followUp: {
        targetSelector: '.cp-profile-img-modal',
        mascot:
          '프로필 이미지를 고른 뒤 "확인"을 누르면 적용돼요. "취소"나 ×를 누르면 적용하지 않고 닫혀요.',
      },
    },
    {
      id: 'save-members',
      mascot: '입력을 마쳤다면 오른쪽 위 "저장하기"를 눌러주세요.',
      targetSelector: '.cp-btn-save-all',
      manualAdvance: true,
    },
    {
      id: 'preset-status-dots',
      mascot:
        '사이드바 "클래스 사전 설정" 메뉴 옆 표시를 확인해 보세요. 필수 입력 자료가 등록되면 V(체크)가 나타나고, 빈 원형이면 아직 입력이 부족한 항목이에요. 빈 원이 보이면 해당 메뉴에서 꼭 자료를 추가해 주세요.',
      targetSelector: '.cp-sidebar-class-individual-expandable .cp-sidebar-preset-status-dot',
      // 세로로 떨어진 상태 점을 하나의 하이라이트로
      spotlightUnion: true,
      manualAdvance: true,
      blockTargetClick: true,
      placement: 'right',
    },
    {
      id: 'go-track-program',
      mascot:
        '이제 편제별 프로그램에 학습내용을 넣어볼게요. 사이드 메뉴에서 "편제별 프로그램"을 펼친 뒤, 원하는 편제 프로그램을 하나 골라 열어 주세요.\n"학습내용 가져오기"는 단원·학습내용 등이 비어 있는 프로그램에서만 활성화돼요. 가져오기를 연습하려면 내용이 비어 있는 편제를 골라 주세요. 이미 내용이 있는 편제면 다음 단계에서 건너뛸 수 있어요.',
      targetSelector: '#cp-sidebar-track-trigger, #cp-sidebar-track-sub .cp-menu-sub-item',
      placement: 'right',
      advanceOnPathPrefix: '/program/track/',
      section: '[편제별 프로그램] 학습내용 가져오기',
      sectionMascot: '편제별 프로그램에 학습내용을 가져와 채워 넣는 구간이에요.',
    },
    {
      id: 'track-import-learning-btn',
      mascot:
        '학습내용이 비어 있으면 "학습내용 가져오기"가 활성화돼요. 버튼을 눌러 가져오기를 진행해 주세요.\n이미 학습내용이 있어 버튼이 비활성화되어 있으면 "다음"을 눌러 가져오기 안내를 건너뛸 수 있어요.',
      // 빈 표 미리보기 버튼이 아닌 실제 툴바 버튼만 (비활성 포함)
      targetSelector:
        'text:학습내용 가져오기@.cp-program-progress-toolbar-group .cp-program-import-learning-toolbar-btn',
      // 모달이 열리면 클릭 진행이 누락돼도 방식 선택 안내로 넘어간다.
      advanceWhenSelectorExists: '[data-tutorial-learning-action-select="import"]',
      // 학습내용이 있어 버튼이 비활성이면 "다음"으로 다른 편제 가져오기·저장 안내로
      manualAdvanceIfExists:
        'text:학습내용 가져오기@.cp-program-progress-toolbar-group .cp-program-import-learning-toolbar-btn:disabled',
      manualAdvanceSkipToStepId: 'track-import-other-programs',
    },
    {
      id: 'track-import-method-csv',
      mascot:
        '"csv파일 가져오기"는 파일로 학습내용을 불러올 때 써요. 지금은 눌러보지 말고 "다음"으로 넘어가 주세요.',
      targetSelector:
        '[data-tutorial-learning-action-select="import"] [data-tutorial-learning-action="csv"]',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'track-import-method-workspace',
      mascot:
        '이번에는 "기본 학습내용 데이터 가져오기"를 눌러 볼게요. 기본 학습내용 등록에 있는 데이터를 이 프로그램으로 가져오는 방식이에요.',
      targetSelector:
        '[data-tutorial-learning-action-select="import"] [data-tutorial-learning-action="workspace"]',
      // 기본 학습내용 모달이 열리면 안내 단계로 넘어간다.
      advanceWhenSelectorExists: '.cp-program-import-learning-modal',
    },
    {
      id: 'track-import-modal-guide',
      mascot:
        '기본 학습내용 가져오기 창이에요. 학년·학기·편제·출판사를 고른 뒤 아래 "데이터 가져오기"를 누르면 학습내용을 불러올 수 있어요. 구성만 살펴본 뒤 "다음"으로 넘어가 주세요.',
      targetSelector:
        '.cp-program-import-learning-grade-tabs, .cp-program-import-learning-modal-sub-tabs, .cp-program-import-learning-template-region, .cp-program-import-learning-publisher-slot, .cp-program-import-learning-modal-footer .cp-btn-primary',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'track-import-modal-practice',
      mascot:
        '선택한 편제에 맞는 학습내용을 가져와 보세요. 학년·학기·편제·출판사를 고른 뒤 "데이터 가져오기" 버튼을 누르면 돼요. 가져오기에 성공하면 다음 안내로 이어져요. 다음에 가져오고 싶으면 "다음"을 눌러 주세요.',
      targetSelector: '.cp-program-import-learning-modal',
      // 데이터 가져오기 클릭 → 모달이 닫히면 자동으로 다음 단계
      advanceSelector: '.cp-program-import-learning-modal-footer .cp-btn-primary',
      manualAdvance: true,
      allowManualAdvanceActions: true,
    },
    {
      id: 'track-import-other-programs',
      mascot:
        '다른 편제들의 학습내용도 가져와 저장해 주세요. 사이드 메뉴의 편제별 프로그램에서 다른 편제를 열어 "학습내용 가져오기"로 채운 뒤, 오른쪽 위 "저장하기"로 저장할 수 있어요.',
      targetSelector:
        '#cp-sidebar-track-trigger, #cp-sidebar-track-sub .cp-menu-sub-item, text:학습내용 가져오기@.cp-program-progress-toolbar-group .cp-program-import-learning-toolbar-btn, .cp-btn-save-all, .cp-program-progress-scroll-wrap, [data-tutorial-learning-action-select="import"] .cp-program-page-split-modal, .cp-program-import-learning-modal',
      placement: 'right',
      manualAdvance: true,
      // 가져오기 방식·기본 학습내용 모달에서 실제로 가져오기·닫기 가능하게
      allowManualAdvanceActions: true,
    },
    {
      id: 'track-import-other-programs-ready',
      mascot:
        '모든 편제의 학습내용을 추가했거나 다음에 작업하고 싶으면 "다음"을 눌러 주세요.',
      targetSelector:
        '#cp-sidebar-track-trigger, #cp-sidebar-track-sub .cp-menu-sub-item, text:학습내용 가져오기@.cp-program-progress-toolbar-group .cp-program-import-learning-toolbar-btn, .cp-btn-save-all, .cp-program-progress-scroll-wrap, [data-tutorial-learning-action-select="import"] .cp-program-page-split-modal, .cp-program-import-learning-modal',
      placement: 'right',
      manualAdvance: true,
      allowManualAdvanceActions: true,
    },
    {
      id: 'go-annual-timetable',
      mascot: '드디어 연간시간표예요! 사이드바에서 이동해요.',
      targetSelector: '.cp-sidebar-primary-annual-timetable',
      placement: 'right',
      section: '[연간시간표] 기초 시간표',
      sectionMascot: '연간시간표의 색상·기초 시간표를 준비하는 구간이에요.',
    },
    {
      id: 'open-timetable-settings',
      mascot: '먼저 기초시간표부터 준비해요. "기초 시간표 설정"을 눌러주세요.',
      targetSelector: '.cp-btn-annual-timetable-settings',
    },
    {
      id: 'fixed-program-colors',
      mascot:
        '고정 프로그램 색상은 행사 등 고정된 시간표에 부여할 색상을 등록하는 곳이에요. 이 색상의 칸은 행사 시간표로 인식돼요. "+"를 누르면 색상을 추가할 수 있어요.',
      targetSelector: '[data-tutorial-color-type="regular"]',
      manualAdvance: true,
      followUp: {
        targetSelector: '[data-tutorial-color-modal-type="regular"]',
        mascot: '라벨 이름을 입력하고 원하는 색상을 고른 뒤 "확인"을 누르면 등록돼요. "취소"를 누르면 등록하지 않고 닫혀요.',
      },
    },
    {
      id: 'dedicated-program-colors',
      mascot:
        '전담 프로그램 색상은 전담 시간에 쓸 색상을 등록하는 곳이에요. 이 색상의 칸은 전담 시간표로 인식돼요. "+"를 누르면 색상을 추가할 수 있어요.',
      targetSelector: '[data-tutorial-color-type="dedicated"]',
      manualAdvance: true,
      followUp: {
        targetSelector: '[data-tutorial-color-modal-type="dedicated"]',
        mascot: '라벨 이름을 입력하고 원하는 색상을 고른 뒤 "확인"을 누르면 등록돼요. "취소"를 누르면 등록하지 않고 닫혀요.',
      },
    },
    {
      id: 'labeling-colors',
      mascot:
        '라벨링 색상은 특별히 구분하고 싶을 때 쓰는 색상이에요. 기초시간표 자동 반영 시 고정·전담과 함께 이 색상의 칸은 덮어쓰이지 않아요. "+"를 누르면 색상을 추가할 수 있어요.',
      targetSelector: '[data-tutorial-color-type="baseExclude"]',
      manualAdvance: true,
      followUp: {
        targetSelector: '[data-tutorial-color-modal-type="baseExclude"]',
        mascot: '라벨 이름을 입력하고 원하는 색상을 고른 뒤 "확인"을 누르면 등록돼요. "취소"를 누르면 등록하지 않고 닫혀요.',
      },
    },
    {
      id: 'base-timetable-input',
      mascot:
        '기초 시간표에는 등록된 편제별 시간표 이름을 입력해요. 등록되지 않은 이름은 붉은색으로 표시돼요. 전담 시간이나 라벨링 색상을 적용해 작성할 수도 있어요.',
      targetSelector: '.cp-timetable-settings-base-input-card',
      manualAdvance: true,
    },
    {
      id: 'save-timetable-settings',
      mascot: '색상과 기초 시간표 입력을 마쳤다면 오른쪽 위 "저장하기"를 눌러주세요. 변경사항이 없어도 버튼을 누르면 다음으로 넘어가요.',
      targetSelector: '.cp-annual-timetable-settings-modal .cp-btn-save-all',
    },
    {
      id: 'close-timetable-settings',
      mascot: '모달을 닫은 뒤 고정 프로그램 등록으로 이어갈게요. × 버튼을 눌러 닫아 주세요.',
      targetSelector: '.cp-annual-timetable-settings-modal-close',
    },
    {
      id: 'event-modal-open',
      mascot: '이번엔 행사처럼 고정된 시간표를 등록하는 방법을 알아볼게요. "고정 프로그램(행사) 등록"을 눌러주세요.',
      targetSelector: 'text:고정 프로그램(행사) 등록@.cp-annual-action-label-full',
      section: '[연간시간표] 고정 프로그램 등록 및 관리',
      sectionMascot: '행사 등 고정 프로그램을 등록·관리하는 구간이에요.',
    },
    {
      id: 'event-modal-date-period',
      mascot: '원하는 날짜를 선택하고 행사진행 교시를 클릭합니다.',
      targetSelector:
        '.cp-annual-event-modal:not(.cp-annual-shortday-modal) .cp-annual-event-date-row, .cp-annual-event-modal:not(.cp-annual-shortday-modal) .cp-annual-event-period-btn',
      manualAdvance: true,
    },
    {
      id: 'event-modal-slot-name',
      mascot: '교시 아래 보이는 시간표 입력 칸에 시간표 이름 양식을 넣어주세요.',
      targetSelector:
        '.cp-annual-event-modal:not(.cp-annual-shortday-modal) .cp-annual-event-slot-name-input',
      manualAdvance: true,
    },
    {
      id: 'event-modal-color-name',
      mascot: '다음으로 원하는 색상을 선택하고 행사명을 입력합니다.',
      targetSelector:
        '.cp-annual-event-modal:not(.cp-annual-shortday-modal) .cp-annual-event-fixed-color-row, .cp-annual-event-modal:not(.cp-annual-shortday-modal) .cp-annual-event-name-in-period-band',
      manualAdvance: true,
    },
    {
      id: 'event-modal-classes',
      mascot:
        '마지막으로 해당 고정(행사) 프로그램이 적용될 클래스를 선택해주세요. 클래스가 2개 이상인 경우 2개 이상의 클래스를 복수 선택할 수 있습니다.',
      targetSelector:
        '.cp-annual-event-modal:not(.cp-annual-shortday-modal) .cp-annual-event-class-select-all-row, .cp-annual-event-modal:not(.cp-annual-shortday-modal) .cp-annual-event-class-blocks-wrap',
      manualAdvance: true,
    },
    {
      id: 'event-modal-apply',
      mascot:
        '다음 진행을 위해서 고정 프로그램을 임의로 하나 등록해 보세요. 내용을 확인한 뒤 "반영"을 눌러주세요. 반영하면 모달이 닫히고 등록이 완료돼요.',
      targetSelector: '.cp-annual-event-modal:not(.cp-annual-shortday-modal)',
      advanceSelector:
        '.cp-annual-event-modal:not(.cp-annual-shortday-modal) .cp-modal-footer .cp-btn-primary',
    },
    {
      id: 'event-modal-repeat',
      mascot:
        '같은 방식으로 "고정 프로그램(행사) 등록"을 다시 열어 계획된 모든 고정(행사) 프로그램을 입력할 수 있어요. 더 등록하거나, 준비되면 다음으로 넘어가세요.',
      targetSelector: 'text:고정 프로그램(행사) 등록@.cp-annual-action-label-full',
      manualAdvance: true,
      followUp: {
        targetSelector: '.cp-annual-event-modal:not(.cp-annual-shortday-modal)',
        mascot:
          '같은 방식으로 계속 등록할 수 있어요. 등록이 끝나면 모달을 닫고, 말풍선의 다음으로 넘어가세요.',
      },
    },
    {
      id: 'event-modal-drag-method',
      mascot:
        '다른 방법도 있어요! 고정 프로그램을 적용하고 싶은 셀을 드래그해서 선택한 뒤, "고정(행사)" 색상 버튼을 눌러 등록 모달을 열어 보세요. 모달에서 정보를 입력해 실습할 수 있어요. 충분히 살펴본 뒤 "다음"으로 넘어가 주세요.',
      targetSelector:
        '.cp-annual-timetable-fixed-table, [data-tutorial-annual-color-group="fixed-event"]',
      manualAdvance: true,
      followUp: {
        targetSelector: '.cp-annual-event-modal:not(.cp-annual-shortday-modal)',
        mascot:
          '셀을 고른 뒤 색상으로 연 등록 창이에요. 정보를 입력하고 "반영"하거나 "취소"로 닫아 보세요. 모달을 닫으면 원래 안내로 돌아가요.',
      },
    },
    {
      id: 'fixed-manage-open',
      mascot: '등록한 고정 프로그램을 수정하거나 삭제할 수도 있어요. "고정 프로그램 관리"를 눌러주세요.',
      targetSelector: 'text:고정 프로그램 관리@.cp-annual-action-label-full',
    },
    {
      id: 'fixed-manage-explain',
      mascot:
        '등록된 고정 프로그램 목록이에요. 항목을 눌러 수정하거나, 휴지통 아이콘으로 삭제할 수 있어요. 지금은 기능만 알아볼게요. 목록을 조작하지 말고 "다음"으로 넘어가 주세요.',
      targetSelector: '.cp-fixed-manage-modal:not(.cp-shortday-manage-modal)',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'fixed-manage-close',
      mascot: '확인이 끝났으면 "닫기"를 눌러 모달을 닫아주세요.',
      targetSelector: '.cp-fixed-manage-modal:not(.cp-shortday-manage-modal) .cp-modal-footer .cp-btn-secondary',
    },
    {
      id: 'shortday-modal-open',
      mascot: '이번엔 증배 및 단축일을 등록하는 방법을 알아볼게요. "증배 및 단축일 등록"을 눌러주세요.',
      targetSelector: 'text:증배 및 단축일 등록@.cp-annual-action-label-full',
      section: '[연간시간표] 증배 및 단축일 등록 및 관리',
      sectionMascot: '증배·단축일을 등록·관리하는 구간이에요.',
    },
    {
      id: 'shortday-modal-date-period',
      mascot:
        '요일별 기준 시간과 다르게 시간이 증배 또는 단축되는 날짜가 있다면 선택하고, 수업을 운영하는 마지막 시간을 클릭하세요.',
      targetSelector:
        '.cp-annual-shortday-modal .cp-annual-event-date-row, .cp-annual-shortday-modal .cp-annual-event-period-btn',
      manualAdvance: true,
    },
    {
      id: 'shortday-modal-classes',
      mascot: '해당 증배·단축일 설정을 적용할 클래스를 모두 선택해주세요.',
      targetSelector:
        '.cp-annual-shortday-modal .cp-annual-event-class-select-all-row, .cp-annual-shortday-modal .cp-annual-event-class-blocks-wrap',
      manualAdvance: true,
    },
    {
      id: 'shortday-modal-apply',
      mascot: '내용을 확인한 뒤 "반영"을 눌러주세요. 반영하면 모달이 닫히고 등록이 완료돼요.',
      targetSelector: '.cp-annual-shortday-modal',
      advanceSelector: '.cp-annual-shortday-modal .cp-modal-footer .cp-btn-primary',
    },
    {
      id: 'shortday-modal-drag-method',
      mascot:
        '다른 방법도 있어요! 증배 또는 단축하고 싶은 셀을 드래그해서 선택한 뒤, "수업"·"활동"·"비수업" 버튼으로 속성을 적용해 보세요. 수업으로 증배하려면 "수업", 단축하려면 "비수업"을 누르면 돼요. 충분히 실습한 뒤 "다음"으로 넘어가 주세요.',
      targetSelector: '.cp-annual-timetable-fixed-table, .cp-annual-table-slot-legend',
      manualAdvance: true,
    },
    {
      id: 'shortday-manage-open',
      mascot: '등록한 증배·단축일도 나중에 확인하고 수정할 수 있어요. "증배 및 단축일 관리"를 눌러주세요.',
      targetSelector: 'text:증배 및 단축일 관리@.cp-annual-action-label-full',
    },
    {
      id: 'shortday-manage-explain',
      mascot:
        '등록된 증배·단축일 목록이에요. 날짜·교시·적용 클래스를 확인하고 필요한 항목을 수정할 수 있어요. 지금은 기능만 알아볼게요. 목록을 조작하지 말고 "다음"으로 넘어가 주세요.',
      targetSelector: '.cp-shortday-manage-modal',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'shortday-manage-close',
      mascot: '확인이 끝났으면 "닫기"를 눌러 모달을 닫아주세요.',
      targetSelector: '.cp-shortday-manage-modal .cp-modal-footer .cp-btn-secondary',
    },
    {
      id: 'apply-base-timetable-term1',
      mascot:
        '이제 준비한 기초시간표를 연간시간표에 채워볼게요. 먼저 "1학기 기초시간표 반영"을 눌러보세요.\n사전 설정에 기초시간표가 없어 버튼이 비활성화되어 있으면 "다음"을 눌러 반영 안내를 건너뛸 수 있어요.',
      targetSelector: 'text:1학기 기초시간표 반영@.cp-annual-base-timetable-apply-btn',
      section: '[연간시간표] 기초시간표 반영',
      sectionMascot: '준비한 기초시간표를 연간시간표에 반영하는 구간이에요.',
      // 기초시간표 미등록 등으로 비활성이면 "다음" → 자동 조정 안내로
      manualAdvanceIfExists:
        'text:1학기 기초시간표 반영@.cp-annual-base-timetable-apply-btn:disabled',
      manualAdvanceSkipToStepId: 'open-hours-adjust',
      followUp: {
        targetSelector: '[aria-labelledby="cp-annual-base-timetable-apply-confirm-title"] .cp-leave-modal-box',
        mascot:
          '고정 프로그램·라벨링 색상을 제외한 영역이 기초시간표로 채워져요. "진행"을 눌러 1학기 반영을 완료해 주세요.',
        advanceSelector:
          '[aria-labelledby="cp-annual-base-timetable-apply-confirm-title"] .cp-leave-modal-box .cp-btn-primary',
      },
    },
    {
      id: 'apply-base-timetable-term2',
      mascot:
        '이어서 "2학기 기초시간표 반영"을 눌러보세요.\n버튼이 비활성화되어 있으면 "다음"을 눌러 반영 안내를 건너뛸 수 있어요.',
      targetSelector: 'text:2학기 기초시간표 반영@.cp-annual-base-timetable-apply-btn',
      manualAdvanceIfExists:
        'text:2학기 기초시간표 반영@.cp-annual-base-timetable-apply-btn:disabled',
      manualAdvanceSkipToStepId: 'open-hours-adjust',
      followUp: {
        targetSelector: '[aria-labelledby="cp-annual-base-timetable-apply-confirm-title"] .cp-leave-modal-box',
        mascot:
          '이번에도 "진행"을 눌러 2학기 기초시간표 반영을 완료해 주세요.',
        advanceSelector:
          '[aria-labelledby="cp-annual-base-timetable-apply-confirm-title"] .cp-leave-modal-box .cp-btn-primary',
      },
    },
    {
      id: 'open-hours-adjust',
      mascot:
        '이제 기준시수에 맞춰 시간표를 자동으로 조정해볼게요. "기준시수 맞춤 시간표 자동 조정"을 눌러주세요.',
      targetSelector: '.cp-annual-hours-adjust-open-btn',
      section: '[연간시간표] 시간표 자동 조정',
      sectionMascot: '기준시수에 맞춰 시간표를 자동 조정하는 구간이에요.',
    },
    {
      id: 'hours-adjust-learning-plan',
      mascot:
        '먼저 "2. 학습계획시수 편차 최소화 자동 조정"을 선택한 뒤, 편제별 1·2학기 학습계획 시수를 입력할 수 있어요. 입력해 두면 실행 시 이 계획과의 편차를 줄이는 방향으로 맞춰줘요.',
      targetSelector: '.cp-annual-hours-adjust-method-btn, .cp-annual-hours-adjust-row-learning',
      manualAdvance: true,
    },
    {
      id: 'hours-adjust-phase1-btn',
      mascot:
        '방식 1을 고른 뒤, 1학기가 아직 구성되지 않았다면 "1·2학기 함께 조정"을, 1학기는 이미 구성돼 있고 2학기만 맞추고 싶다면 "2학기만 조정"을 눌러주세요.',
      targetSelector:
        'text:1·2학기 함께 조정@.cp-annual-hours-adjust-phase-btn, text:2학기만 조정@.cp-annual-hours-adjust-phase-btn',
    },
    {
      id: 'hours-adjust-phase1-checklist-btn',
      mascot:
        '1번으로 조정된 시수로 바로 시간표를 바꾸고 싶다면 "시수 조정 체크리스트 생성"으로 체크리스트를 만들 수 있어요. 이번엔 2번 조정까지 진행할 거라 클릭은 건너뛰고 "다음"을 눌러주세요.',
      targetSelector: 'text:시수 조정 체크리스트 생성@.cp-annual-hours-adjust-checklist-cta',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'hours-adjust-phase2-btn',
      mascot:
        '방식 2를 고른 뒤 "기준시수 맞춤 + 학습계획 편차 최소화 실행"을 누르면, 기준시수 맞춤과 학습계획 편차 최소화가 한 번에 진행돼요.',
      targetSelector:
        'text:기준시수 맞춤 + 학습계획 편차 최소화 실행@.cp-annual-hours-adjust-phase-btn',
    },
    {
      id: 'hours-adjust-phase2-checklist-btn',
      mascot:
        '2번 결과로 시간표를 조정하려면 "시수 조정 체크리스트 생성 (2)"를 눌러 체크리스트를 열어볼게요.',
      targetSelector: 'text:시수 조정 체크리스트 생성 (2)@.cp-annual-hours-adjust-checklist-cta',
    },
    {
      id: 'hours-adjust-checklist-apply-btn',
      mascot:
        '체크리스트에서 옮길 항목을 확인한 뒤 "체크리스트 자동 반영"을 누르면 시간표에 한 번에 반영돼요.\n"옮길 시수가 없습니다"라고 나오면 원본과 조정 결과가 같아서 반영할 내용이 없는 상태예요. 확인했으면 "다음"으로 넘어가 주세요.',
      targetSelector: '.cp-hours-adjust-checklist-float',
      manualAdvance: true,
    },
    {
      id: 'hours-adjust-checklist-close',
      mascot:
        '확인이 끝났으면 체크리스트 창의 ×(닫기)를 눌러 주세요. 닫으면 다음 안내로 이어져요.',
      targetSelector: '.cp-hours-adjust-checklist-float-close',
    },
    {
      id: 'labeling-color-apply',
      mascot:
        '셀을 선택한 뒤 "라벨링 색상" 버튼을 누르면 그 색이 적용돼요. 라벨링 색상 칸은 기초시간표 자동 반영 때 덮어쓰이지 않아요. 셀을 고르면 "다음"이 활성화돼요.',
      targetSelector:
        '.cp-annual-timetable-fixed-table, [data-tutorial-annual-color-group="labeling"]',
      manualAdvance: true,
      manualAdvanceEnableWhen:
        '.cp-annual-timetable-fixed-table td.cp-base-timetable-cell-selected',
      section: '[연간시간표] 시간표 색상 적용 및 편집 기능',
      sectionMascot: '라벨링 색상 적용과 셀 편집·이동 기능을 알아보는 구간이에요.',
    },
    {
      id: 'cell-move-left',
      mascot:
        '선택한 셀(또는 영역)을 왼쪽으로 한 칸 옮길 때 쓰는 버튼이에요. 셀을 고른 뒤 "←"를 눌러보세요. 셀을 고르면 "다음"이 활성화돼요.',
      targetSelector: '.cp-annual-timetable-fixed-table, [aria-label="선택 셀 왼쪽 이동"]',
      manualAdvance: true,
      manualAdvanceEnableWhen:
        '.cp-annual-timetable-fixed-table td.cp-base-timetable-cell-selected',
    },
    {
      id: 'cell-move-right',
      mascot: '"→"는 선택한 셀을 오른쪽으로 한 칸 옮겨요. 셀을 고르면 "다음"이 활성화돼요.',
      targetSelector: '.cp-annual-timetable-fixed-table, [aria-label="선택 셀 오른쪽 이동"]',
      manualAdvance: true,
      manualAdvanceEnableWhen:
        '.cp-annual-timetable-fixed-table td.cp-base-timetable-cell-selected',
    },
    {
      id: 'cell-move-up',
      mascot: '"↑"는 선택한 셀을 위로 한 칸 옮겨요. 셀을 고르면 "다음"이 활성화돼요.',
      targetSelector: '.cp-annual-timetable-fixed-table, [aria-label="선택 셀 위로 이동"]',
      manualAdvance: true,
      manualAdvanceEnableWhen:
        '.cp-annual-timetable-fixed-table td.cp-base-timetable-cell-selected',
    },
    {
      id: 'cell-move-down',
      mascot: '"↓"는 선택한 셀을 아래로 한 칸 옮겨요. 셀을 고르면 "다음"이 활성화돼요.',
      targetSelector: '.cp-annual-timetable-fixed-table, [aria-label="선택 셀 아래로 이동"]',
      manualAdvance: true,
      manualAdvanceEnableWhen:
        '.cp-annual-timetable-fixed-table td.cp-base-timetable-cell-selected',
    },
    {
      id: 'swap-region-a',
      mascot:
        '맞교환할 한쪽 영역을 먼저 지정해요. 셀을 선택한 뒤 "교환영역 A"를 누르면 A로 기억돼요. (단축키 Shift+Q)\n셀을 고르면 "다음"이 활성화돼요.',
      targetSelector:
        '.cp-annual-timetable-fixed-table, [title="선택 영역을 교환영역 A로 지정 (Shift+Q)"]',
      manualAdvance: true,
      manualAdvanceEnableWhen:
        '.cp-annual-timetable-fixed-table td.cp-base-timetable-cell-selected',
    },
    {
      id: 'swap-region-b',
      mascot:
        '다른 쪽 셀을 선택한 뒤 "교환영역 B"를 누르면 B로 지정돼요. (단축키 Shift+W)\n셀을 고르면 "다음"이 활성화돼요.',
      targetSelector:
        '.cp-annual-timetable-fixed-table, [title="선택 영역을 교환영역 B로 지정 (Shift+W)"]',
      manualAdvance: true,
      manualAdvanceEnableWhen:
        '.cp-annual-timetable-fixed-table td.cp-base-timetable-cell-selected',
    },
    {
      id: 'swap-regions',
      mascot:
        'A와 B를 모두 지정했다면 "영역 바꾸기"로 두 영역의 내용을 맞교환할 수 있어요. (단축키 Shift+E)\n셀을 고르면 "다음"이 활성화돼요.',
      targetSelector: '.cp-annual-timetable-fixed-table, [title="영역 A와 B 맞교환 (Shift+E)"]',
      manualAdvance: true,
      manualAdvanceEnableWhen:
        '.cp-annual-timetable-fixed-table td.cp-base-timetable-cell-selected',
    },
    {
      id: 'annual-timetable-compose',
      mascot:
        '앞서 알아본 기능을 활용해서 1·2학기 시간표를 구성해 보세요. 구성법을 알았거나 구성이 완료되면 "다음"을 눌러주세요. 연간시간표는 언제든 변경할 수 있어서, 미완성이라도 다음으로 진행할 수 있어요.',
      targetSelector: '.cp-annual-timetable-classes-stack',
      manualAdvance: true,
    },
    {
      id: 'save-timetable',
      mascot: '시간표를 확인하고 "저장하기"를 눌러주세요.',
      targetSelector: '.cp-btn-save-all',
      manualAdvance: true,
    },
    {
      id: 'operation-plan-exceed-intro',
      mascot:
        '연간 수업 일수·시수 운영계획을 제대로 활용하려면, 시간표를 편집해 기준시수를 넘도록 시수를 조정해 두는 과정이 필요해요. 1·2학기 표를 편집해 편성시수가 기준시수 이상이 되도록 맞춰 보세요. 충분하면 "다음"을 눌러 주세요.',
      targetSelector: '.cp-annual-timetable-classes-stack',
      manualAdvance: true,
      section: '[연간시간표] 연간 수업 일수 및 시수 운영계획',
      sectionMascot: '시수표·주간 교육활동과 연간 운영계획 문서를 확인하는 구간이에요.',
    },
    {
      id: 'operation-plan-hours-summary',
      mascot:
        '1학기·2학기 시간표 사이에 있는 시수표예요. 편성시수(학기 시수·총 시수)와 기준시수, 편차를 한눈에 확인할 수 있어요. 확인했으면 "다음"을 눌러 주세요.',
      targetSelector: '.cp-annual-term-summary-block',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'operation-plan-week-hours-hover',
      mascot:
        '수업시수 열에 마우스를 올리면 해당 주에 편성된 편제별 시수를 확인할 수 있어요. 올려본 뒤 "다음"을 눌러 주세요.',
      targetSelector: '.cp-weekly-schedule-th-hours, .cp-annual-week-hours-cell',
      manualAdvance: true,
    },
    {
      id: 'operation-plan-week-memo-click',
      mascot:
        '일자 열의 기간(날짜 범위) 셀을 클릭하면 주간 교육활동을 등록할 수 있어요. 셀을 눌러 창을 열어 보세요.',
      targetSelector: '.cp-annual-week-memo-anchor-cell',
    },
    {
      id: 'operation-plan-week-memo-popup',
      mascot:
        '여기에 주간 교육활동과 일반 메모를 입력할 수 있어요. 확인했으면 창을 닫거나 "다음"을 눌러 주세요.',
      targetSelector: '.cp-annual-week-memo-floating-wrap',
      advanceWhenSelectorGone: '.cp-annual-week-memo-floating-wrap',
      manualAdvance: true,
      allowManualAdvanceActions: true,
    },
    {
      id: 'operation-plan-open-btn',
      mascot: '이제 "연간 수업 일수 및 시수 운영계획" 버튼을 눌러주세요.',
      targetSelector: '.cp-btn-annual-action-operation-plan',
    },
    {
      id: 'operation-plan-modal',
      mascot:
        '연간 수업 일수 및 시수 운영계획 화면이에요. 주별 수업일수·수업시수를 확인하고, 주요 교육활동이 자동으로 표시돼요. 충분히 살펴본 뒤 "다음"을 눌러 주세요.',
      targetSelector: '.cp-annual-operation-plan-modal',
      advanceWhenSelectorGone: '.cp-annual-operation-plan-modal',
      manualAdvance: true,
      allowManualAdvanceActions: true,
    },
    {
      id: 'go-annual-progress',
      mascot: '거의 다 왔어요! 이제 연간진도표에서 학습내용을 입력해볼게요. 사이드바에서 "1학기 연간진도표"를 눌러주세요.',
      targetSelector: '.cp-sidebar-annual-progress-link-t1',
      placement: 'right',
      section: '[연간시간표] [편제별 프로그램] 기록 및 편집 방법',
      sectionMascot: '연간진도표와 편제별 프로그램에서 학습내용·탐색·범교과·진도 계획을 다루는 구간이에요.',
    },
    {
      id: 'annual-progress-today-lesson',
      mascot:
        '이 표는 조회용이라 바로 입력할 수는 없어요. "오늘 학습내용 보기"를 누르면 오늘 날짜의 수업(행)이 자동으로 선택돼요.',
      targetSelector: 'text:오늘 학습내용 보기@.cp-annual-progress-action-label-full',
      manualAdvance: true,
    },
    {
      id: 'nav-explore-timetable-select',
      mascot:
        '먼저 연간진도표에서 탐색할 수업을 선택해 보세요. 원하는 행(셀)을 클릭하면 "다음"이 활성화돼요. 선택한 뒤 "다음"을 눌러주세요.',
      targetSelector: '[data-tutorial-table-body="annual-progress"]',
      manualAdvance: true,
      // 셀을 고르기 전에는 "다음"으로 건너뛰지 못하게
      manualAdvanceEnableWhen:
        '[data-tutorial-table-body="annual-progress"] td.cp-base-timetable-cell-selected',
    },
    {
      id: 'nav-explore-timetable',
      mascot:
        '이제 "선택셀 연간시간표 탐색"(↑ 탐색)을 누르면 선택한 수업이 있는 연간시간표 위치로 바로 이동해요. 단축키는 Shift+F예요. 버튼이나 단축키로 이동해 주세요.\n탐색 버튼이 비활성화되어 있으면 표에서 다른 셀을 선택해 보세요. 그래도 비활성이면 셀을 고른 뒤 "다음"을 눌러 사이드 메뉴로 연간시간표를 여는 안내로 이어가요.',
      // 표에서 셀을 다시 고를 수 있게 표+탐색 버튼을 함께 하이라이트
      targetSelector:
        '[data-tutorial-table-body="annual-progress"], [data-tutorial-browse="annual-timetable"]',
      advanceSelector: '[data-tutorial-browse="annual-timetable"]',
      advanceShortcut: { key: 'f', shift: true },
      advanceOnPathPrefix: '/annual-timetable',
      // 탐색 성공 시 셀 선택 단계로. 사이드바 안내 단계는 건너뜀.
      advanceGoToStepId: 'nav-back-to-progress-from-timetable-select',
      // 탐색 버튼 disabled일 때만 "다음" 노출 → 사이드바 안내로.
      manualAdvanceIfExists: '[data-tutorial-browse="annual-timetable"]:disabled',
      // 셀을 한 번이라도 고른 뒤에만 soft-lock "다음" 활성화
      manualAdvanceEnableWhen:
        '[data-tutorial-table-body="annual-progress"] td.cp-base-timetable-cell-selected',
      manualAdvanceSkipToStepId: 'nav-open-annual-timetable-via-sidebar',
    },
    {
      id: 'nav-open-annual-timetable-via-sidebar',
      mascot:
        '사이드 메뉴에서 "연간시간표"를 클릭해서 페이지를 열어 주세요. 페이지를 열면 안내가 이어져요.',
      targetSelector: '.cp-sidebar-primary-annual-timetable',
      placement: 'right',
      advanceOnPathPrefix: '/annual-timetable',
      advanceGoToStepId: 'nav-back-to-progress-from-timetable-select',
    },
    {
      id: 'nav-back-to-progress-from-timetable-select',
      mascot:
        '돌아갈 수업을 연간시간표 표에서 선택해 보세요. 셀을 고르면 "다음"이 활성화돼요. 선택한 뒤 "다음"을 눌러주세요.',
      targetSelector: '.cp-annual-timetable-fixed-table tbody',
      manualAdvance: true,
      manualAdvanceEnableWhen:
        '.cp-annual-timetable-fixed-table tbody td.cp-base-timetable-cell-selected',
    },
    {
      id: 'nav-back-to-progress-from-timetable',
      mascot:
        '이제 "선택셀 연간진도표 탐색"을 누르면 다시 연간진도표로 돌아올 수 있어요. 단축키는 Shift+G예요. 버튼이나 단축키로 돌아와 주세요.\n탐색 버튼이 비활성화되어 있으면 표에서 다른 셀을 선택해 보세요. 그래도 비활성이면 셀을 고른 뒤 "다음"을 눌러 사이드 메뉴로 연간진도표를 여는 안내로 이어가요.',
      targetSelector:
        '.cp-annual-timetable-fixed-table tbody, [data-tutorial-browse="annual-progress"]',
      advanceSelector: '[data-tutorial-browse="annual-progress"]',
      advanceShortcut: { key: 'g', shift: true },
      advanceOnPathPrefix: ['/annual-progress-term1', '/annual-progress-term2'],
      // 탐색 성공 시 프로그램 선택 단계로. 사이드바 안내 단계는 건너뜀.
      advanceGoToStepId: 'nav-explore-program-select',
      manualAdvanceIfExists: '[data-tutorial-browse="annual-progress"]:disabled',
      manualAdvanceEnableWhen:
        '.cp-annual-timetable-fixed-table tbody td.cp-base-timetable-cell-selected',
      manualAdvanceSkipToStepId: 'nav-open-annual-progress-mid-via-sidebar',
    },
    {
      id: 'nav-open-annual-progress-mid-via-sidebar',
      mascot:
        '사이드 메뉴에서 목표로 하는 연간진도표(1학기 또는 2학기)를 클릭해서 이동해 주세요. 페이지를 열면 안내가 이어져요.',
      targetSelector:
        '.cp-sidebar-annual-progress-link-t1, .cp-sidebar-annual-progress-link-t2',
      placement: 'right',
      advanceOnPathPrefix: ['/annual-progress-term1', '/annual-progress-term2'],
      advanceGoToStepId: 'nav-explore-program-select',
    },
    {
      id: 'nav-explore-program-select',
      mascot:
        '이번엔 프로그램(진도표)로 갈 수업을 표에서 선택해 보세요. 가능하면 편제가 있는 학습내용 셀을 고른 뒤 "다음"을 눌러주세요. 셀을 고르면 "다음"이 활성화돼요.',
      targetSelector: '[data-tutorial-table-body="annual-progress"]',
      manualAdvance: true,
      manualAdvanceEnableWhen:
        '[data-tutorial-table-body="annual-progress"] td.cp-base-timetable-cell-selected',
    },
    {
      id: 'nav-explore-program',
      mascot:
        '이제 "선택셀 프로그램 탐색"을 눌러, 선택한 수업이 속한 프로그램(진도표) 페이지로 가볼게요. 단축키는 Shift+G예요. 버튼이나 단축키로 이동해 주세요.\n편제가 없는 학습내용을 고르면 버튼이 비활성화돼요. 그때는 표에서 편제가 있는 셀을 다시 골라 보세요. 그래도 비활성이면 셀을 고른 뒤 "다음"을 눌러 사이드 메뉴로 프로그램 페이지를 여는 안내로 이어가요.',
      targetSelector:
        '[data-tutorial-table-body="annual-progress"], [data-tutorial-browse="program"]',
      advanceSelector: '[data-tutorial-browse="program"]',
      advanceShortcut: { key: 'g', shift: true },
      advanceOnPathPrefix: '/program/',
      // 탐색 성공 시 학습내용 하이라이트 단계로. 사이드바 안내 단계는 건너뜀.
      advanceGoToStepId: 'program-learning-input',
      // 편제 없는 셀 → 탐색 버튼 disabled일 때만 "다음" 노출 → 사이드바 안내로.
      manualAdvanceIfExists: '[data-tutorial-browse="program"]:disabled',
      manualAdvanceEnableWhen:
        '[data-tutorial-table-body="annual-progress"] td.cp-base-timetable-cell-selected',
      manualAdvanceSkipToStepId: 'nav-open-program-via-sidebar',
    },
    {
      id: 'nav-open-program-via-sidebar',
      mascot:
        '사이드 메뉴에서 프로그램 페이지(고정·프로젝트·편제별 프로그램)를 클릭해서 페이지를 열어 주세요. 페이지를 열면 프로그램 안내가 이어져요.',
      targetSelector: '.cp-sidebar-program-block .cp-sidebar-program-type-expandable',
      placement: 'right',
      advanceOnPathPrefix: '/program/',
      // 탐색 하이라이트 단계는 건너뛰고 편집 도구 안내부터.
      advanceGoToStepId: 'program-row-add',
    },
    {
      id: 'program-learning-input',
      mascot:
        '연간진도표에서 선택한 학습내용의 원본 데이터가 있는 프로그램 진도표 위치를 바로 선택해서 볼 수 있어요. 여기 "학습내용" 칸에서 그날 배울 내용을 직접 입력·수정할 수 있어요.',
      targetSelector:
        '.cp-program-progress-scroll-wrap tbody td.cp-base-timetable-cell-selected',
      manualAdvance: true,
    },
    {
      id: 'program-row-add',
      mascot:
        '지금부터는 편집 도구를 왼쪽부터 하나씩, 기능만 알아볼게요. 지금은 버튼을 누르지 말고 "다음"으로 넘어가 주세요. 나중에 실제 편집할 때 활용해 보세요.\n"+"(수업 추가)는 선택한 행 아래에 새 수업 행을 추가해요.',
      targetSelector: '.cp-program-progress-toolbar [title*="수업(편집내용) 행 추가"]',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'program-row-remove',
      mascot:
        '"-"(수업 삭제)는 선택한 수업 행을 삭제해요. 지금은 기능만 알아보는 중이에요. 나중에 활용해 보세요.',
      targetSelector: '.cp-program-progress-toolbar [title="선택한 수업(편집내용) 행 삭제"]',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'program-row-merge',
      mascot:
        '"통합"(수업 통합)은 선택한 여러 행의 수업 내용을 규칙에 따라 하나로 합쳐요. 같은 시간표의 학습내용만 통합할 수 있어요. 지금은 기능만 알아보는 중이에요.',
      targetSelector: '.cp-program-progress-toolbar [title="선택 행의 수업 내용을 규칙에 따라 통합"]',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'program-duplicate',
      mascot:
        '"증배"(수업 증배)는 선택한 한 행을 바로 아래에 복제해서 넣어요. (수업기록은 복제되지 않아요) 지금은 기능만 알아보는 중이에요.',
      targetSelector: '.cp-program-progress-toolbar [title="선택한 단일 행을 바로 아래에 복제 삽입(수업기록 제외)"]',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'program-row-up',
      mascot:
        '"편집내용 올리기"(↑↓)는 선택한 행의 편집 내용을 한 칸 위로 옮겨요. 지금은 기능만 알아보는 중이에요.',
      targetSelector: '.cp-program-progress-toolbar [title="선택한 행의 편집 영역을 한 칸 위로 이동"]',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'program-row-down',
      mascot:
        '"편집내용 내리기"(↓↑)는 선택한 행의 편집 내용을 한 칸 아래로 옮겨요. 지금은 기능만 알아보는 중이에요.',
      targetSelector: '.cp-program-progress-toolbar [title="선택한 행의 편집 영역을 한 칸 아래로 이동"]',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'program-period-count',
      mascot:
        '"차시 카운트"(차시 자동 카운트)는 대단원·소단원을 구분하는 기호를 정하면 해당 차시·전체 차시를 자동으로 매겨줘요. 지금은 기능만 알아보는 중이에요.',
      targetSelector: '.cp-program-progress-toolbar [title*="해당차시·전체차시를 자동 번호 매김"]',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'program-copy',
      mascot:
        '"복사"는 선택한 셀 내용을 복사해요. (단축키 Ctrl/Cmd+C) 지금은 기능만 알아보는 중이에요.',
      targetSelector: '.cp-program-progress-toolbar [title="복사 (Ctrl/Cmd + C)"]',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'program-cut',
      mascot:
        '"잘라내기"는 선택 영역을 오려서 다른 칸에 옮겨 붙일 수 있게 해요. (단축키 Ctrl/Cmd+X) 지금은 기능만 알아보는 중이에요.',
      targetSelector: '.cp-program-progress-toolbar [title="잘라내기 (Ctrl/Cmd + X)"]',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'program-paste',
      mascot:
        '"붙여넣기"는 복사·잘라낸 내용이나 엑셀 표를 선택한 칸에 넣어요. (단축키 Ctrl/Cmd+V) 지금은 기능만 알아보는 중이에요.',
      targetSelector: '.cp-program-progress-toolbar [title*="붙여넣기 (Ctrl/Cmd + V)"]',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'program-delete',
      mascot:
        '"데이터 삭제"는 행은 그대로 두고 선택 영역의 내용만 지워요. 지금은 기능만 알아보는 중이에요. 나중에 실제 편집할 때 활용해 보세요.',
      targetSelector: '.cp-program-progress-toolbar [title="선택 영역 데이터 삭제"]',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'program-head-page',
      mascot:
        '표 머리글의 "쪽수" 버튼을 누르면 쪽수에 입력된 쪽수와 보조쪽수를 손쉽게 분리할 수 있어요.\n쪽수와 보조쪽수가 함께 입력된 경우 둘을 구분짓는 시작 기호를 입력하고 분리하기를 실행하면 쪽수열과 보조쪽수열에 자동으로 나누어 입력해줘요.\n지금은 기능만 알아볼게요. 버튼을 누르지 말고 "다음"으로 넘어가 주세요.',
      targetSelector: 'text:쪽수@.cp-program-progress-record-head-btn',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'program-head-cross',
      mascot:
        '"범교과" 버튼을 누르면, 선택한 학습내용의 범교과 셀이 자동으로 선택되고 입력 모달(팝업)이 열려요. 지금은 기능만 알아보는 중이에요.',
      targetSelector: 'text:범교과@.cp-program-progress-record-head-btn',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'program-head-memo',
      mascot:
        '"메모" 버튼도 같아요. 선택한 학습내용의 메모 셀을 자동 선택하고 입력 모달을 열어줘요. 지금은 기능만 알아보는 중이에요.',
      targetSelector: 'text:메모@.cp-program-progress-record-head-btn',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'program-head-eval',
      mascot:
        '"평가" 버튼은 선택한 학습내용의 평가 셀을 자동 선택하고 입력 모달을 열어줘요. 지금은 기능만 알아보는 중이에요.',
      targetSelector: 'text:평가@.cp-program-progress-record-head-btn',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'program-head-classlog',
      mascot:
        '"수업기록" 버튼은 선택한 학습내용의 수업기록 셀을 자동 선택하고 입력 모달을 열어줘요. 지금은 기능만 알아보는 중이에요. 이어서 셀을 직접 눌러 입력 창을 열어볼게요.',
      targetSelector: 'text:수업기록@.cp-program-progress-record-head-btn',
      manualAdvance: true,
      blockTargetClick: true,
    },
    {
      id: 'program-cross-cell-click',
      mascot: '이번엔 "범교과" 칸을 클릭해서 입력 창을 열어볼게요. 반짝이는 칸을 눌러 주세요.',
      targetSelector: '.cp-program-progress-scroll-wrap tbody td:nth-child(17)',
      followUp: {
        targetSelector: '.cp-program-cross-popup',
        mascot:
          '이 창에서는 범교과 "주제어"와 "내용"을 입력할 수 있어요. 이제 "범교과 예시문 가져오기"를 눌러 예시문 선택 창을 열어볼게요.',
        advanceSelector: '.cp-program-cross-catalog-import-btn',
      },
    },
    {
      id: 'program-cross-example-modal',
      mascot:
        '여기서 주제어를 고르고 원하는 학습내용을 선택한 뒤 "반영"을 누르면 범교과 칸에 바로 채워져요. 지금은 살펴보기만 하고, "반영"은 눌러보지 마세요. 원하는 만큼 본 뒤 "다음"으로 넘어가 주세요.',
      targetSelector: '.cp-cross-curricular-catalog-picker-modal',
      manualAdvance: true,
    },
    {
      id: 'program-memo-cell-click',
      mascot: '이어서 "메모" 칸을 클릭해서 메모 입력 창을 열어볼게요. 반짝이는 칸을 눌러 주세요.',
      targetSelector: '.cp-program-progress-scroll-wrap tbody td:nth-child(18)',
      followUp: {
        targetSelector: '.cp-program-note-popup',
        mascot:
          '이 창에는 수업과 관련한 메모를 자유롭게 적을 수 있어요. 확인을 누르면 저장되고, 닫기를 누르면 반영하지 않고 창이 닫혀요. 원하는 만큼 살펴본 뒤 "다음"으로 넘어가 주세요.',
        manualAdvance: true,
      },
    },
    {
      id: 'program-eval-cell-click',
      mascot: '"평가" 칸을 한 번 클릭하면 평가 결과를 빠르게 고르는 목록이 나와요. 반짝이는 칸을 눌러 주세요.',
      targetSelector: '.cp-program-progress-scroll-wrap tbody td:nth-child(19)',
      followUp: {
        targetSelector: '.cp-program-eval-dropdown',
        mascot:
          '한 번 클릭하면 나오는 목록에서 평가 결과를 바로 고를 수 있어요. 지금은 살펴보기만 하고, "다음"으로 넘어가 주세요.',
        manualAdvance: true,
        blockTargetClick: true,
      },
    },
    {
      id: 'program-eval-longpress-hint',
      mascot:
        '같은 "평가" 칸을 1초 정도 길게 누르면 평가계획과 연동해 더 자세히 기록하는 확장 창이 열려요. 한 번 길게 눌러보세요. (어렵다면 "다음"으로 건너뛸 수 있어요)',
      targetSelector: '.cp-program-progress-scroll-wrap tbody td:nth-child(19)',
      manualAdvance: true,
      followUp: {
        targetSelector: '.cp-program-note-popup',
        mascot:
          '길게 누르면 열리는 확장 창에서 평가 결과와 메모를 자세히 남길 수 있어요. "평가계획 가져오기"를 누르면 클래스에 적용된 평가계획을 골라 연결할 수 있어요.\n#이름 뒤에 스페이스바를 입력하면 해당 이름 태그 칩이 만들어지고, 태그 칩 뒤에 적은 기록을 태그별로 모아 볼 수 있어요.\n가져오기 창은 직접 조작해 보고, 확장 창의 닫기·확인은 지금은 잠겨 있어요. 원하는 만큼 살펴본 뒤 "다음"으로 넘어가 주세요.',
        manualAdvance: true,
      },
    },
    {
      id: 'program-classrecord-cell-click',
      mascot: '"수업기록" 칸을 클릭하면 수업 진행 내용이나 평가 기록을 남기는 창이 열려요. 반짝이는 칸을 눌러 주세요.',
      targetSelector: '.cp-program-progress-scroll-wrap tbody td:nth-child(20)',
      followUp: {
        targetSelector: '.cp-program-note-popup',
        mascot:
          '열린 창에서 수업기록/평가기록 탭으로 구분해 적고, 멤버 그룹을 지정하면 특정 학생에게 태그도 할 수 있어요.\n#이름 뒤에 스페이스바를 입력하면 해당 이름 태그 칩이 만들어지고, 태그 칩 뒤에 적은 기록을 태그별로 모아 볼 수 있어요.\n확인을 누르면 저장되고, 닫기를 누르면 반영하지 않고 창이 닫혀요. 원하는 만큼 살펴본 뒤 "다음"으로 넘어가 주세요.',
        manualAdvance: true,
      },
    },
    {
      id: 'nav-back-to-annual-progress-final',
      mascot:
        '이제 "선택셀 연간진도표 탐색"을 눌러 다시 연간진도표로 돌아가볼게요. 단축키는 Shift+F예요. 버튼이나 단축키로 이동해 주세요.\n탐색 버튼이 비활성화되어 있으면 표에서 셀을 선택해 보세요. 그래도 비활성이면 셀을 고른 뒤 "다음"을 눌러 사이드 메뉴로 이동하는 안내로 이어가요.',
      targetSelector:
        '.cp-program-progress-scroll-wrap tbody, [data-tutorial-browse="annual-progress"]',
      advanceSelector: '[data-tutorial-browse="annual-progress"]',
      advanceShortcut: { key: 'f', shift: true },
      advanceOnPathPrefix: ['/annual-progress-term1', '/annual-progress-term2'],
      // 탐색 성공 시 학습내용 표시 단계로. 사이드바 안내 단계는 건너뜀.
      advanceGoToStepId: 'annual-progress-learning-display',
      manualAdvanceIfExists: '[data-tutorial-browse="annual-progress"]:disabled',
      manualAdvanceEnableWhen:
        '.cp-program-progress-scroll-wrap tbody td.cp-base-timetable-cell-selected',
      manualAdvanceSkipToStepId: 'nav-open-annual-progress-via-sidebar',
    },
    {
      id: 'nav-open-annual-progress-via-sidebar',
      mascot:
        '사이드 메뉴에서 목표로 하는 연간진도표(1학기 또는 2학기)를 클릭해서 이동해 주세요. 페이지를 열면 안내가 이어져요.',
      targetSelector:
        '.cp-sidebar-annual-progress-link-t1, .cp-sidebar-annual-progress-link-t2',
      placement: 'right',
      advanceOnPathPrefix: ['/annual-progress-term1', '/annual-progress-term2'],
      // 탐색으로 돌아온 학습내용 하이라이트는 건너뛰고 범교과 안내로
      advanceGoToStepId: 'cross-topic-count-btn',
    },
    {
      id: 'annual-progress-learning-display',
      mascot:
        '프로그램 진도표에서 선택했던 학습내용이에요. 이렇게 연간진도표의 원래 위치에도 바로 표시돼서 한눈에 확인할 수 있어요.',
      targetSelector: '[data-tutorial-table-body="annual-progress"] td.cp-base-timetable-cell-selected',
      manualAdvance: true,
    },
    {
      id: 'cross-topic-count-btn',
      mascot:
        '"1,2학기 범교과 주제 카운팅"을 누르면 1·2학기에서 범교과 주제가 몇 번씩 쓰였는지 한눈에 볼 수 있어요.',
      targetSelector: 'text:1,2학기 범교과 주제 카운팅@.cp-annual-progress-year-action-label-full',
    },
    {
      id: 'cross-topic-count-modal',
      mascot: '여기서 학기별로 등록된 범교과 주제 횟수를 확인할 수 있어요.',
      targetSelector: '.cp-annual-cross-topic-count-modal',
      manualAdvance: true,
    },
    {
      id: 'progress-plan-btn',
      mascot:
        '"연간 진도 계획 및 편제별 진도 계획"을 누르면 전체 연간 진도 계획과 편제별 진도 계획을 확인·내보낼 수 있어요.',
      targetSelector:
        'text:연간 진도 계획 및 편제별 진도 계획@.cp-annual-progress-year-action-label-full',
    },
    {
      id: 'progress-plan-modal',
      mascot:
        '여기서 연간 진도 계획, 편제별 진도 계획 문서를 확인하고 내려받을 수 있어요. 살펴본 뒤 "다음"을 눌러 주세요.',
      targetSelector: '.cp-neis-learning-upload-modal',
      manualAdvance: true,
      allowManualAdvanceActions: true,
    },
    {
      id: 'progress-plan-neis-click',
      mascot:
        '이번에는 "NEIS 업로드 학습내용" 버튼을 눌러 활성화해 보세요. 버튼을 누르면 다음으로 이어져요.\n이미 활성화되어 있으면 "다음"을 눌러 주세요.',
      targetSelector: '.cp-neis-learning-upload-mode-btn',
      advanceSelector: '.cp-neis-learning-upload-mode-btn',
      advanceImmediately: true,
      // 이미 활성화된 상태면 "다음"으로 넘어갈 수 있게
      manualAdvanceIfExists: '.cp-neis-learning-upload-mode-btn--active',
    },
    {
      id: 'progress-plan-neis-export',
      mascot:
        '활성화한 뒤 xls 파일로 내려받으면, NEIS 학습내용 등록에 나의 계획에 맞는 순서로 짜여진 학습내용을 손쉽게 업로드할 수 있어요. 확인했으면 "다음"을 눌러 주세요.',
      targetSelector:
        '.cp-neis-learning-upload-mode-btn--active, .cp-neis-learning-upload-header-actions',
      manualAdvance: true,
      allowManualAdvanceActions: true,
    },
    {
      id: 'behavior-cell-click',
      mascot: '표 맨 오른쪽 "행동특성" 칸을 클릭하면 학생 행동특성을 기록하는 창이 열려요.',
      targetSelector: '.cp-annual-progress-col-log',
    },
    {
      id: 'behavior-modal',
      mascot:
        '여기에 행동특성 내용을 적고, 멤버 그룹을 지정해 특정 학생에게 태그할 수도 있어요.\n#이름 뒤에 스페이스바를 입력하면 해당 이름 태그 칩이 만들어지고, 태그 칩 뒤에 적은 기록을 태그별로 모아 볼 수 있어요.',
      targetSelector: '.cp-program-note-popup',
      manualAdvance: true,
    },
    {
      id: 'outro',
      mascot:
        '기본 교육과정 구성을 모두 마쳤어요. 클래스 사전 설정부터 연간시간표·연간진도표까지 기본 흐름을 익히셨으니, 이제 실제 학급 자료로 이어서 구성해 보세요.',
      actionLabel: '완료',
      presentation: 'celebration',
      cardTitle: '축하합니다!',
      placement: 'center',
    },
  ],
};

const coreOnboarding: TutorialDefinition = {
  ...coreOnboardingRaw,
  steps: coreOnboardingRaw.steps.map((step) => {
    const recover = RECOVER_BY_STEP_ID[step.id];
    if (!recover && !step.targetMissingHint) return step;
    const targetMissingHint = buildTutorialTargetMissingHint(recover, step.targetMissingHint);
    return {
      ...step,
      ...(recover ? { recover } : {}),
      targetMissingHint,
    };
  }),
};

export default coreOnboarding;
